<template>
    <div class="fine_plays_select_page" v-if="finePlay">
        <div class="fine_play_branch">
            <span>{{finePlay.institution.official_name_kanji}}</span>
            <span>{{finePlay.presenter_company_code}}</span>
            <span>{{finePlay.presenter_market_code}}</span>
        </div>
        <div class="fine_plays_group_message">
            <div v-for="message in finePlay.fine_plays" class="fine_play_message_item">
                <div class="message_date_name">
                    <span class="name">{{message.display_name}}</span>
                    <span class="date">{{message.message_created_at | dateTimeFormat}}</span>
                </div>
                <div class="message_content">
                    <span v-html="message.content"></span>
                </div>
            </div>
        </div>
        <div class="fine_plays_group_button" v-if="myFinePlayHistoryStatus === 'preapproval' && finePlay.can_approve">
            <div class="approval" @click="handleClickApprove">承認</div>
            <div class="denial" @click="handleClickDenial">否認</div>
        </div>
        <div class="sub-header">承認履歴</div>
        <div class="fine_play_info">
            <div class="employee">
                <div class="text">
                    <span class="date">{{finePlay.created_at | dateFormat}}</span>
                    <span class="name">{{`${finePlay.presenter_company_code} ${finePlay.employee.name_kanji}`}}</span>
                </div>
                <div class="status"><span>申請者</span></div>
            </div>
            <div class="fine_play_histories">
                <div class="employee" v-for="employee in finePlay.fine_play_histories">
                    <div class="text">
                        <span class="date" :class="{'show': employee.status !== 'preapproval'}">{{employee.created_at | dateFormat}}</span>
                        <span class="name">{{`${employee.recipient_company_code} ${employee.recipient.name_kanji}`}}</span>
                    </div>
                    <div class="status">
                        <span
                            :class="{'approval': employee.status === 'approval', 'denial': employee.status === 'denial'}"
                            v-if="employee.status !== 'preapproval'"
                        >{{employee.status === 'approval' ? '承認済' : '否認'}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import FineplayApi from '../../api/fine-plays'

  export default {
    data () {
      return {
        finePlay: null,
        myFinePlayHistoryStatus: null
      }
    },
    methods: {
      ...mapActions({
        setLinks: 'navigator/setLinks',
        getNumberUnReadApprove: 'masterData/getUnreadFineplayApprove'
      }),
      async fetchData () {
        const loading = this.$loading.show()
        try {
          const res = await FineplayApi.show(this.$route.params.finePlayId)
          this.finePlay = res.data.data
          const index = this.finePlay.fine_play_histories.findIndex(n => n.recipient_employee_code === this.$auth.watch.data.employee_code)
          if (index !== -1) this.myFinePlayHistoryStatus = this.finePlay.fine_play_histories[index].status
          loading.hide()
        } catch (e) {
          console.error(e)
          loading.hide()
          this.$message({message: 'アクセス権限を持ってありません、!', type: 'error'})
        }
      },
      async handleClickApprove () {
        const loading = this.$loading.show()
        try {
          const res = await FineplayApi.approve(this.finePlay.id)
          this.finePlay = res.data.data
          const index = this.finePlay.fine_play_histories.findIndex(n => n.recipient_employee_code === this.$auth.watch.data.employee_code)
          this.myFinePlayHistoryStatus = this.finePlay.fine_play_histories[index].status
          this.$message({message: 'ファインプレーの承認が完了しました!', type: 'success'})
          this.getNumberUnReadApprove()
        } catch (e) {
          this.$message({message: 'ファインプレーの承認が失敗しました!', type: 'error'})
        }
        loading.hide()
      },
      async handleClickDenial () {
        const loading = this.$loading.show()
        try {
          const res = await FineplayApi.denial(this.finePlay.id)
          this.finePlay = res.data.data
          const index = this.finePlay.fine_play_histories.findIndex(n => n.recipient_employee_code === this.$auth.watch.data.employee_code)
          this.myFinePlayHistoryStatus = this.finePlay.fine_play_histories[index].status
          this.$message({message: 'ファインプレーの否認が完了しました!', type: 'success'})
          this.getNumberUnReadApprove()
        } catch (e) {
          this.$message({message: 'ファインプレーの承認が失敗しました!', type: 'error'})
        }
        loading.hide()
      }
    },
    async mounted () {
      await this.fetchData()

      if (this.finePlay) {
        this.setLinks([
          {title: `${this.finePlay.employee.display_name}`, route: {name: 'finePlayApproves'}}
        ])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/fine-plays-approve/show.vue